<template>
    <div ref="volumeControl"></div>
</template>

<script>
import videojs from 'video.js';
import { toRaw } from 'vue';

export default {
    name: 'SbsVideoPlayerVolume',
    inject: {
        videoPlayerComponent: { default: null },
    },
    data: () => ({
        volumeControlComponent: null,
    }),
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
    },
    methods: {
        handleMouseUp(event) {
            const currentVolumeX = event.offsetX;
            const totlatVolumeX = this.volumeControlComponent?.getChild('VolumeBar')?.el().offsetWidth ?? 0;
            const volumeLevel = currentVolumeX > totlatVolumeX ? 1 : currentVolumeX / totlatVolumeX;

            this.player.volume(volumeLevel);
        },
    },
    mounted() {
        const VolumeControl = videojs.getComponent('volumeControl');
        const volumeControl = this.player.controlBar.addChild('ClickableComponent', {
            el: this.$refs.volumeControl,
        });

        this.volumeControlComponent = new VolumeControl(this.player);
        this.volumeControlComponent?.on('mouseup', this.handleMouseUp);
        volumeControl.addChild(this.volumeControlComponent);
    },
    beforeUnmount() {
        this.volumeControlComponent.off('mouseup', this.handleMouseUp);
    },
};
</script>

<style lang="scss">
.vjs-volume-control.vjs-volume-horizontal {
    .video-js & {
        margin-right: 0;
    }

    .vjs-volume-bar.vjs-slider-horizontal {
        width: 56px;
        margin: 19px 0;
    }

    .vjs-volume-level {
        .video-js & {
            background-color: var(--video-player-theme);
            border-radius: $rounded-5;
        }

        &::before {
            display: none;
            color: var(--video-player-theme);
        }
    }
}

.vjs-volume-control:hover {
    .vjs-volume-level::before {
        display: block;
    }

    .vjs-volume-tooltip {
        display: none;
    }
}
</style>
